"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProfileVo = void 0;
const uuid_1 = require("uuid");
const addresses_1 = require("../exceptions/addresses");
const wrongCountryId_exception_1 = require("../exceptions/addresses/wrongCountryId.exception");
const paymentProfiles_1 = require("../exceptions/paymentProfiles");
const countriesList_1 = require("./addressVo/countriesList");
const statesList_1 = require("./addressVo/statesList");
class PaymentProfileVo {
    constructor(separator, version) {
        this._separator = '%%%';
        this._version = 'v01';
        this._separator = separator;
        this._version = version;
        this.uid = (0, uuid_1.v4)();
        this.providerName = 'AUTHORIZE';
        this.providerSettingsId = '';
        this.customerProfileId = '';
        this.profileId = '';
        this.cardType = 'VISA';
        this.first6Digits = '';
        this.last4Digits = '';
        this.expirationDate = '';
        this.firstName = '';
        this.lastName = '';
        this._country = 'United States of America';
        this.zipCode = '';
        this._state = '';
        this.city = '';
        this.address1 = '';
        this.address2 = '';
    }
    isValid() {
        return !!this.providerSettingsId &&
            !!this.customerProfileId &&
            !!this.profileId &&
            !!this.firstName &&
            !!this.lastName &&
            !!this.address1 &&
            !!this.city &&
            !!this.state &&
            !!this.zipCode &&
            !!this.country &&
            !!this.first6Digits &&
            !!this.last4Digits &&
            !!this.expirationDate;
    }
    validate() {
        if (!this.providerSettingsId)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty provider settings id');
        if (!this.customerProfileId)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty customer profile id');
        if (!this.profileId)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty profile id');
        if (!this.firstName)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty first name');
        if (!this.lastName)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty last name');
        if (!this.address1)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty address');
        if (!this.city)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty city');
        if (!this.state)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty state');
        if (!this.zipCode)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty zip code');
        if (!this.country)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty country');
        if (!this.first6Digits)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty first 6 digits');
        if (!this.last4Digits)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty last 4 digits');
        if (!this.expirationDate)
            throw new paymentProfiles_1.BrokenPaymentProfileException('empty expiration date');
    }
    static createNewProfile() {
        return new PaymentProfileVo('%%%', 'v01');
    }
    static createFromString(profileAsString) {
        // First three symbols defining the profiles string separator
        const separator = profileAsString.slice(0, 3);
        if (!separator) {
            throw new paymentProfiles_1.BrokenPaymentProfileException(`can't define separator in string ${profileAsString}`);
        }
        const version = profileAsString.slice(3, 6);
        if (!version) {
            throw new paymentProfiles_1.BrokenPaymentProfileException(`can't define version in string ${profileAsString}`);
        }
        const sourceProfile = profileAsString.slice(6, profileAsString.length);
        if (!sourceProfile) {
            throw new paymentProfiles_1.BrokenPaymentProfileException(`profile is empty`);
        }
        const paymentProfileData = this.convertFromString(separator, version, sourceProfile);
        const newProfile = new PaymentProfileVo(separator, version);
        newProfile.uid = paymentProfileData.uid || '';
        newProfile.providerName = paymentProfileData.providerName || '';
        newProfile.providerSettingsId = paymentProfileData.providerSettingsId || '';
        newProfile.customerProfileId = paymentProfileData.customerProfileId || '';
        newProfile.profileId = paymentProfileData.profileId || '';
        newProfile.cardType = paymentProfileData.cardType || '';
        newProfile.first6Digits = paymentProfileData.first6Digits || '';
        newProfile.last4Digits = paymentProfileData.last4Digits || '';
        newProfile.expirationDate = paymentProfileData.expirationDate || '';
        newProfile.firstName = paymentProfileData.firstName || '';
        newProfile.lastName = paymentProfileData.lastName || '';
        newProfile.address1 = paymentProfileData.address1 || '';
        newProfile.address2 = paymentProfileData.address2 || '';
        newProfile.city = paymentProfileData.city || '';
        newProfile.state = paymentProfileData.state || '';
        newProfile.zipCode = paymentProfileData.zipCode || '';
        newProfile.country = paymentProfileData.country || '';
        return newProfile;
    }
    getSafeString(source) {
        return source.replace(this._separator, ' ');
    }
    saveToString() {
        this.validate();
        switch (this._version) {
            case 'v01':
            default:
                // Payment profile format v01
                // [sep]v01UID[sep]PROVIDER_NAME[sep]PROVIDER_SETTINGS_ID[sep]CUSTOMER_PROFILE_ID[sep]PROFILE_ID[sep]CARD_TYPE[sep]FIRST6DIGITS[sep]LAST4DIGITS[sep]EXPIRATION_DATE[sep]FIRST_NAME[sep]LAST_NAME[sep]ADDRESS_1[sep]ADDRESS_2[sep]CITY[sep]STATE[sep]ZIP_CODE[sep]COUNTRY
                return `${this._separator}${this._version}${[
                    this.getSafeString(this.uid),
                    this.getSafeString(this.providerName),
                    this.getSafeString(this.providerSettingsId),
                    this.getSafeString(this.customerProfileId),
                    this.getSafeString(this.profileId),
                    this.getSafeString(this.cardType),
                    this.getSafeString(this.first6Digits),
                    this.getSafeString(this.last4Digits),
                    this.getSafeString(this.expirationDate),
                    this.getSafeString(this.firstName),
                    this.getSafeString(this.lastName),
                    this.getSafeString(this.address1),
                    this.getSafeString(this.address2),
                    this.getSafeString(this.city),
                    this.getSafeString(this.state),
                    this.getSafeString(this.zipCode),
                    this.getSafeString(this.country)
                ].join(this._separator)}`;
        }
    }
    static convertFromString(separator, version, addressAsString) {
        switch (version) {
            case 'v01':
            default:
                return this.convertFromStringVersion01(separator, addressAsString);
        }
    }
    // Payment profile format for v01
    // UID[sep]PROVIDER_NAME[sep]PROVIDER_SETTINGS_ID[sep]CUSTOMER_PROFILE_ID[sep]PROFILE_ID[sep]CARD_TYPE[sep]FIRST6DIGITS[sep]LAST4DIGITS[sep]EXPIRATION_DATE[sep]FIRST_NAME[sep]LAST_NAME[sep]ADDRESS_1[sep]ADDRESS_2[sep]CITY[sep]STATE[sep]ZIP_CODE[sep]COUNTRY
    static convertFromStringVersion01(separator, profileAsString) {
        const arrayOfFields = profileAsString.split(separator);
        if (arrayOfFields.length !== 17)
            throw new paymentProfiles_1.BrokenPaymentProfileException(`wrong number of fields in version v01`);
        const [uid, providerName, providerSettingsId, customerProfileId, profileId, cardType, first6Digits, last4Digits, expirationDate, firstName, lastName, address1, address2, city, state, zipCode, country] = arrayOfFields;
        return {
            uid,
            providerName: providerName,
            providerSettingsId,
            customerProfileId,
            profileId,
            cardType: cardType,
            first6Digits,
            last4Digits,
            expirationDate,
            firstName,
            lastName,
            address1,
            address2,
            city,
            state,
            zipCode,
            country
        };
    }
    displayPreview() {
        return `${this.first6Digits}•• •••• ${this.last4Digits} ${this.expirationDate} ${this.cardType}, ${this.firstName} ${this.lastName}, ${this.address}, ${this.city}, ${this.state}, ${this.zipCode}, ${this.country}`;
    }
    isPresentInList(listOfAddressesVo) {
        return listOfAddressesVo.some((item) => item.displayPreview() === this.displayPreview());
    }
    get address() {
        return this.address2 ? `${this.address1} ${this.address2}` : this.address1;
    }
    get country() {
        return this._country;
    }
    set country(newCountryName) {
        const fixedCountryName = countriesList_1.countriesListIsoToFullName[newCountryName.toLowerCase()];
        if (fixedCountryName) {
            this._country = fixedCountryName;
        }
        else {
            this._country = newCountryName;
        }
    }
    get countryId() {
        const countryId = countriesList_1.countriesListIso2ToId[this.countryIso2];
        if (!countryId)
            throw new wrongCountryId_exception_1.WrongCountryIdException(this.country);
        return countryId;
    }
    get countryIso2() {
        const countryIso2 = countriesList_1.countriesListNameToIso2[this.country.toLowerCase()];
        if (!countryIso2)
            throw new addresses_1.WrongCountryException(this.country);
        return countryIso2;
    }
    get state() {
        return this._state;
    }
    set state(newStateName) {
        const fixedState = statesList_1.statesList[this.countryIso2][newStateName.toLowerCase()];
        if (fixedState) {
            this._state = fixedState.label;
        }
        else {
            this._state = newStateName;
        }
    }
    get stateIso2() {
        const regionInfo = statesList_1.statesList[this.countryIso2][this.state.toLowerCase()];
        if (!regionInfo)
            throw new addresses_1.WrongRegionException(this.state);
        return regionInfo.iso2;
    }
}
exports.PaymentProfileVo = PaymentProfileVo;
//# sourceMappingURL=paymentProfileVo.js.map